import { SelectionModel } from '@angular/cdk/collections';
import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { AuthService } from 'app/auth/auth.service';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { HelplistService } from 'app/helplist.service';
import { IPDService } from 'app/ipd/Services/ipdServices.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { BillingserviceService } from '../billingService.service';
@Component({
  selector: 'app-add-package',
  templateUrl: './add-package.component.html',
  styleUrls: ['./add-package.component.scss']
})
export class AddPackageComponent implements OnInit {
  selectId: any;
  todaysdate = this.authService.getServerDate;
  displayedColumns: string[] = ['packageName', 'packageAmount'];
  dataSource = new MatTableDataSource<any>();
  selection = new SelectionModel<any>(true, []);
  public SelectedServiceArray: any = [];

  constructor(public dialog: MatDialog, public helplistservice: HelplistService, public datepipe: DatePipe,
    public authService: AuthService, public dashboardService: DashboardService, public ipdService: IPDService
    , public dialogRef: MatDialogRef<AddPackageComponent>, @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    public opdvisitService: OpdVisitService, private billingservice: BillingserviceService) { }

  ngOnInit(): void {
    this.ipdService.selectedServiceRow = null;
    var id = this.data.id;
    var Type = this.data.Type;
    var date = this.dashboardService.selecteddate;
    this.getPackageList(Type, id, date);
  }

  getPackageList(a, b, c) {
   
    this.ipdService.GetpackageList(a, b, c).subscribe(data => {
      this.dataSource.data = data;
      // console.log('package',  this.dataSource.data);
    })
  }



  applyFilter_grid(filterValue) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

  }


  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data?.forEach(row => this.selection.select(row));

  }

 

  closedialog() {
    this.dialog.closeAll();
    this.SelectedServiceArray = [];
  }


  getrowdata(row: any) {
    this.SelectedServiceArray.push(row);
    this.ipdService.selectedServiceRow = this.SelectedServiceArray;
    this.dialog.closeAll();

  }
}
